/**
 * Wrapper for QuickCreateMenu that navigates to the document import page.
 * Previously opened AccountingDocumentUpload dialog; now uses the unified import flow.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface QuickCreateDocumentUploadFormProps {
  open: boolean;
  onClose: () => void;
}

export function QuickCreateDocumentUploadForm({ open, onClose }: QuickCreateDocumentUploadFormProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      navigate('/accounting/import-bills/new');
      onClose();
    }
  }, [open, navigate, onClose]);

  return null;
}
